export default __webpack_public_path__ + "static/3-31090c0b32c97b16536eb5bba92e79e6.jpg";